<template>
  <el-dialog
    :visible.sync="DialogShow"
    @closed="closeDialog"
    @open="openDialog"
    append-to-body
  >
    <div slot="title" class="dialog-title">
      <span class="title-line"></span>
      <span class="title-text">{{ title }}</span>
    </div>
    <el-form
      :model="submitFormData"
      :rules="rules"
      ref="form"
      label-width="160px"
      class="demo-submitFormData"
      style="padding: 20px 0 10px 60px"
    >
      <el-form-item
        v-for="(val, inx) of editFormDefaulteArr"
        :key="inx"
        :label="val.name"
        :prop="val.fieldName"
        :rules="[
          {
            required: val.required,
            message: `${val.name}不能为空`,
            trigger: 'change',
          },
        ]"
      >
        <el-input
          size="small"
          v-model="submitFormData[val.fieldName]"
          :class="val.size"
          v-if="val.type == 'input'"
          clearable
        ></el-input>
        <el-input
          size="small"
          :class="val.size"
          clearable
          v-if="val.type == 'password'"
          type="password"
          v-model="submitFormData[val.fieldName]"
          autocomplete="off"
        ></el-input>
        <el-select
          v-if="val.type == 'select'"
          size="small"
          :class="val.size"
          clearable
          v-model="submitFormData[val.fieldName]"
        >
          <el-option
            :label="item[val.selectValue]"
            :value="item[val.selectId]"
            v-for="item in val.selectList"
            :key="item[val.selectId]"
          ></el-option>
        </el-select>
        <el-select
          v-if="val.type == 'selectMultiple'"
          multiple
          size="small"
          :class="val.size"
          clearable
          v-model="submitFormData[val.fieldName]"
        >
          <el-option
            :label="item[val.selectValue]"
            :value="item[val.selectId]"
            v-for="item in val.selectList"
            :key="item[val.selectId]"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="from-btn-wrap">
      <el-button type="primary" @click="handelClickSubmit" size="small">{{
        upDataMsg
      }}</el-button>
      <el-button type="primary" plain size="small" @click="handelClickCancel"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'upDataFormPackaging',
  data() {
    return {
      submitFormData: {},
      rules: {},
      DialogShow: false,
      upDataMsg: '保存',
    };
  },
  props: {
    title: {
      type: String,
      default: function () {
        return '';
      },
    },
    editFormDefaulteArr: {
      type: Array,
      default: function () {
        return '';
      },
    },
  },
  mounted() {},
  methods: {
    openDialog() {
      this.submitFormData = {};
      this.$nextTick(() => {
        this.editFormDefaulteArr.forEach((val) => {
          this.$set(this.submitFormData, val.fieldName, val.value);
        });
        if (this.title.indexOf('新建') != -1) {
          this.$refs.form.resetFields();
        }
      });

      // this.$refs.form.clearValidate();
      // console.log(this.$sha256('123456'));
    },
    closeDialog() {
      this.DialogShow = false;
      this.$refs.form.resetFields();
    },
    //提交
    handelClickSubmit() {
      if (this.upDataMsg == '保存') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.upDataMsg = '保存中...';
            this.$emit('editUpData', this.submitFormData);
          }
        });
      }
      // this.$emit('editUpData', this.submitFormData);
    },
    //取消
    handelClickCancel() {
      this.closeDialog();
    },
  },
  components: {},
};
</script>
<style lang='scss' scoped>
</style>